import styles from './textField.module.css';
type TextFieldProps = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "onChange"
> & {
    label: string;
    disabled?: boolean;
    value: string;
    placeholder?: string;
    customStyles?: React.CSSProperties;
    inputAlign?: 'left' | 'right';
    type?: string;
    suffix?: React.ReactNode;
    mutedPlaceholder?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const TextField = ({ label, disabled, value, placeholder, customStyles, inputAlign = 'left', type = "text", suffix, mutedPlaceholder, onChange, ...props }: TextFieldProps
) => {
    return (
        <div className={styles.textField} style={customStyles}>
            <label>{label}</label>
            <input
                disabled={disabled}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                style={{ textAlign: inputAlign }}
                type={type}
                className={mutedPlaceholder ? styles["muted-placeholder"] : ""}
                {...props}
            />
            {suffix && (
                <span className={styles["text-field-suffix"]}>
                    {suffix}
                </span>
            )}
        </div>
    )
}